/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/alt-text */
import { ReactComponent as ChevronDown } from "../assets/icons/chevrons/chevron-down.svg";
import { useAuth } from "../store/useAuth";
import {
  Menu,
  MenuHandler,
  MenuItem,
  MenuList,
} from "@material-tailwind/react";
import { ReactComponent as LogoutIcon } from "../assets/icons/navbar/logout.svg";
import { useEffect, useMemo } from "react";
import { useNavigate } from "react-router";
import { useLeftMenu } from "../store/useLeftMenu";
import { useNotifications } from "../store/useNotifications";
import { ReactComponent as DropsIcon } from "../assets/icons/menu/drops-icon.svg";
import { useDropLocations } from "../store/useDropLocations";

export function Navbar() {
  /** Hooks */
  const { logout, user } = useAuth();
  const navigate = useNavigate();
  const { isOpen, setIsOpen } = useLeftMenu();
  const { getNotifications, notifications } = useNotifications();
  const { getDropLocations } = useDropLocations();

  /** Callbacks */
  const userRole = useMemo(() => {
    if (user?.user_role === 1) {
      return "Admin";
    }
    if (user?.user_role === 5) {
      return "Store Admin";
    }
    if (user?.user_role === 2) {
      return "Manager";
    }
    if (user?.user_role === 7) {
      return "Super Admin";
    }
    return "User";
  }, [user?.user_role]);

  useEffect(() => {
    getNotifications();
    getDropLocations();
  }, []);

  const openProfileScreen = () => navigate("/profile");

  return (
    <div className="h-15 ml-1 rounded-lg mr-2 bg-white flex items-center justify-end px-4 sm:px-7 py-4 fixed top-0 left-0 right-0 sm:left-72 z-[99999999]">
      <div className="flex-1 flex-row items-center">
        <button
          onClick={() => setIsOpen(!isOpen)}
          type="button"
          className="flex-1 items-center p-2 ms-3 text-sm text-gray-500 rounded-lg sm:hidden hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200 dark:text-gray-400 dark:hover:bg-gray-700 dark:focus:ring-gray-600"
        >
          <svg
            className="w-6 h-6"
            aria-hidden="true"
            fill="currentColor"
            viewBox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              clipRule={"evenodd"}
              fillRule="evenodd"
              d="M2 4.75A.75.75 0 012.75 4h14.5a.75.75 0 010 1.5H2.75A.75.75 0 012 4.75zm0 10.5a.75.75 0 01.75-.75h7.5a.75.75 0 010 1.5h-7.5a.75.75 0 01-.75-.75zM2 10a.75.75 0 01.75-.75h14.5a.75.75 0 010 1.5H2.75A.75.75 0 012 10z"
            ></path>
          </svg>
        </button>
        {/* <div className="hidden sm:flex flex-row items-center">
          <FormSelect
            inputClassName="h-[38px] px-2 bg-sky-lighter text-sm"
            // @ts-ignore
            options={[
              { value: "all", label: "All locations" },
              // @ts-ignore
              ...(dropLocations?.map((location) => ({
                value: location?._id as string,
                label: location?.cost_place as string,
              })) ?? []),
            ]}
            value={currentLocation as string}
            onChange={(e) => setCurrentLocation(e.target.value)}
            placeholder="Change location here..."
          />
        </div> */}
      </div>
      <div className="flex flex-row items-center">
        <Menu>
          <MenuHandler>
            {notifications?.length ? (
              <div>
                <img
                  src={require("../assets/icons/notifications/onNotification.png")}
                  className="w-6 h-6 cursor-pointer"
                />
                <div className="w-[20px] h-[20px] rounded-full bg-red-700 absolute top-6 ml-3.5 flex flex-row items-center justify-center">
                  <p className="text-white font-satoshi text-xs font-bold">
                    {notifications?.length}
                  </p>
                </div>
              </div>
            ) : (
              <img
                src={require("../assets/icons/notifications/offNotification.png")}
                className="w-6 h-6 cursor-pointer"
              />
            )}
          </MenuHandler>
          <MenuList className="rounded-lg mt-4" placeholder={undefined}>
            {/* <NotificationItems /> */}
            {notifications?.length ? (
              notifications?.map((notification) => (
                <MenuItem
                  className="font-satoshi text-base text-dark flex flex-1 items-center"
                  placeholder={undefined}
                  onClick={() => navigate(`/edit-drop/${notification?.id}`)}
                >
                  <div className="w-[25px] h-[25px] rounded-full flex items-center justify-center bg-red-200 mr-2">
                    <DropsIcon className="h-[15px] w-[15px]" />
                  </div>
                  <span className="font-satoshi text-base text-dark">
                    {notification?.subTitle}
                  </span>
                </MenuItem>
              ))
            ) : (
              <MenuItem
                className="font-satoshi text-base text-dark"
                placeholder={undefined}
              >
                No Notifications
              </MenuItem>
            )}
          </MenuList>
        </Menu>
        <Menu>
          <MenuHandler>
            <div className="flex cursor-pointer justify-end items-center px-7 flex-1">
              <div className="flex flex-col items-end mr-4 cursor-pointer">
                <span className="font-satoshi font-medium text-sm text-tailgrids-black">
                  {user?.first_name} {user?.last_name}
                </span>
                <span className="font-satoshi font-medium text-xs text-tailgrids-text">
                  {userRole}
                </span>
              </div>
              <img
                className="w-11 h-11 mr-3 rounded-full cursor-pointer"
                src={
                  user?.profileImage ??
                  require("../assets/pictures/dummy/dummy-avatar.png")
                }
              />
              <ChevronDown className="cursor-pointer" />
            </div>
          </MenuHandler>
          <MenuList className="rounded-lg" placeholder={undefined}>
            <MenuItem
              onClick={openProfileScreen}
              className="font-satoshi text-base text-dark"
              placeholder={undefined}
            >
              Profile
            </MenuItem>
            <MenuItem
              onClick={logout}
              className="font-satoshi text-base text-red-darkest flex items-center"
              placeholder={undefined}
            >
              <LogoutIcon className="mr-2" />
              Logout
            </MenuItem>
          </MenuList>
        </Menu>
      </div>
    </div>
  );
}
